import React, { useContext, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import { formatDate } from "../../../../utils/misc";

import {
  Button,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TextField,
  Tabs,
  Tab
} from "@mui/material";

import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Switch from "@mui/material/Switch";

import WorkflowDropdown from "./KiosksListDialog/WorkflowDropdown";
import KiosksListTableBody from "./KiosksListDialog/KiosksListTableBody";

import { useTheme } from "@mui/material/styles";

import { WORKFLOW_MODES } from "../../../../constants";

export default function KioskListDialog({
  subscription,
  open,
  handleSetWorkflowModeKiosk,
  handleClose,
  handleSetWorkflowModeSubscription,
  kioskListForceRefreshToggle
}) {
  const theme = useTheme();

  const [filterKioskID, setFilterKioskID] = useState("");
  const [subscriptions, setSubscriptions] = useState(subscription);
  const [tabsValue, setTabsValue] = useState(0);

  const [activeSubscriptions, setActiveSubscriptions] = useState(0);
  const [inactiveSubscriptions, setInactiveSubscriptions] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabsValue(newValue);
  };

  useEffect(() => {
    setSubscriptions(subscription);
    setTabsValue(0);
    console.log("DEBUG KiosksListDialog.js subscription", subscription);

    console.log("KioskListDialog.js subscription", subscription);

    try {
      if (subscription) {
        setActiveSubscriptions(
          subscription.kioskKeys.filter(kiosks => kiosks.active == true).length
        );

        setInactiveSubscriptions(
          subscription.kioskKeys.filter(kiosks => kiosks.active == false).length
        );
      }
    } catch (err) {
      console.error("KioskListDialog" + err);
    }
  }, [subscription, kioskListForceRefreshToggle]);

  return (
    <React.Fragment>
      <Dialog
        fullWidth={false}
        maxWidth={false}
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-kiosklist"
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginTop: theme.spacing(2),
            marginLeft: theme.spacing(1.5), //Inline with Kiosk ID Search Text
            marginRight: theme.spacing(2)
          }}
        >
          <DialogTitle id="modal-kiosklist">
            Device List for {subscriptions ? subscriptions.locationName : ""} [
            {subscriptions ? subscriptions.locationCode : ""}]
          </DialogTitle>

          <div>
            {/* //Batch Update */}
            <FormControl sx={{ m: 1, minWidth: 230 }}>
              <InputLabel id="batch-update-select-label">
                Batch update all workflow
              </InputLabel>
              <Select
                labelId="batch-update-open-select-label"
                id="batch-update-open-select"
                label="Workflow Mode"
                onChange={async event => {
                  // //TODO: Check if this function is used
                  let results = await handleSetWorkflowModeSubscription(
                    subscriptions._id,
                    event.target.value
                  );
                  // // console.log(
                  // //   "KioskListDialog.js results from update",
                  // //   results
                  // // );
                  // // setSubscriptions(results);
                  // //TODO: We can update just the affected kiosks here to make it more efficient
                  // //TODO: For now, Maybe just trigger a refresh is better
                }}
              >
                <MenuItem value={WORKFLOW_MODES.BAGS_AND_LABELS}>
                  Bag and Labels
                </MenuItem>
                <MenuItem value={WORKFLOW_MODES.BAG_ONLY}>Bags Only</MenuItem>
                <MenuItem value={WORKFLOW_MODES.BAG_ONLY_WITH_AUTH}>
                  Bags Only With Authenication
                </MenuItem>
              </Select>
            </FormControl>
          </div>
        </div>
        <DialogContent>
          <DialogContentText></DialogContentText>
          <Box
            noValidate
            component="form"
            sx={{
              display: "flex",
              flexDirection: "column",
              m: "auto",
              width: "fit-content"
            }}
          >
            <TextField
              id="ks"
              label="Kiosk ID Search"
              value={filterKioskID}
              onChange={event => {
                let newText = event.target.value;
                setFilterKioskID(newText);
              }}
              style={{ marginTop: "1em" }}
              size="small"
            />

            <Tabs
              value={tabsValue}
              onChange={handleTabChange}
              aria-label="disabled tabs example"
            >
              <Tab
                label={
                  "All (" + (activeSubscriptions + inactiveSubscriptions) + ")"
                }
              />
              <Tab label={"Active (" + activeSubscriptions + ")"} />
              <Tab label={"Inactive (" + inactiveSubscriptions + ")"} />
            </Tabs>

            <TableContainer>
              <Table
                style={{
                  marginTop: theme.spacing(2)
                  //display: loading ? "none" : null
                }}
              >
                <TableHead>
                  <TableRow>
                    <TableCell>Kiosk ID</TableCell>
                    <TableCell>Device ID</TableCell>
                    <TableCell>Serial ID</TableCell>
                    <TableCell>Version</TableCell>
                    <TableCell align="left">Created IP</TableCell>
                    <TableCell align="left">Workflow Mode</TableCell>
                    {/* <TableCell align="left">Bagtags</TableCell> */}
                    {/* <TableCell align="left">Check Data</TableCell> */}
                    <TableCell align="left">Logs</TableCell>
                    <TableCell align="left">Last Accessed</TableCell>
                    <TableCell align="left">Created</TableCell>
                    <TableCell align="center">Active</TableCell>
                  </TableRow>
                </TableHead>
                <KiosksListTableBody
                  subscriptions={subscriptions}
                  filterKioskID={filterKioskID}
                  filterTabIndex={tabsValue}
                  handleSetWorkflowModeKiosk={handleSetWorkflowModeKiosk}
                />
              </Table>
            </TableContainer>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
